const TOOLTIP_IDS = Object.freeze({
  TOBI: 'TOBI',
  TRAY: 'TRAY',
  MAIN_CARDS: 'MAINCARDS',
});

export default TOOLTIP_IDS;
